var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountriespresence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "url(#paint0_linear_468_12417)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_12417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.36 22H23.3333C22.9797 22 22.6406 22.1405 22.3905 22.3905C22.1405 22.6406 22 22.9797 22 23.3333V26.36",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 14.2267V15.3334C16.6665 15.8638 16.8772 16.3725 17.2523 16.7476C17.6274 17.1226 18.1361 17.3334 18.6665 17.3334C19.0201 17.3334 19.3593 17.4738 19.6093 17.7239C19.8594 17.9739 19.9998 18.3131 19.9998 18.6667C19.9998 19.4 20.5998 20 21.3332 20C21.6868 20 22.0259 19.8595 22.276 19.6095C22.526 19.3594 22.6665 19.0203 22.6665 18.6667C22.6665 17.9334 23.2665 17.3334 23.9998 17.3334H26.1132",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 26.6333V24C19.3334 23.6464 19.1929 23.3072 18.9428 23.0572C18.6928 22.8071 18.3537 22.6666 18 22.6666C17.6464 22.6666 17.3073 22.5262 17.0572 22.2761C16.8072 22.0261 16.6667 21.6869 16.6667 21.3333V20.6666C16.6667 20.313 16.5262 19.9739 16.2762 19.7238C16.0261 19.4738 15.687 19.3333 15.3334 19.3333H13.3667",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 26.6666C23.6821 26.6666 26.6668 23.6819 26.6668 20C26.6668 16.3181 23.6821 13.3333 20.0002 13.3333C16.3183 13.3333 13.3335 16.3181 13.3335 20C13.3335 23.6819 16.3183 26.6666 20.0002 26.6666Z",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_12417",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDFAF3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_12417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountriespresence);
export default __webpack_public_path__ + "static/media/countriespresence.84f3c94e09e1ae2225b4f7373c446e59.svg";
export { ForwardRef as ReactComponent };